import React, { useEffect } from 'react';
import { debounce } from '@/helpers/utils';
import styles from './DragDrop.module.scss';

type DragDropProps = {
  children: React.ReactNode;
  id: string;
  className?: string;
  onDrop: (files: FileList) => void;
};

const DragDrop: React.FC<DragDropProps> = (props) => {
  const { children, id, className = '', onDrop } = props;
  const classes = `${styles.DropZone} ${className}`;
  const ref = React.createRef() as React.RefObject<HTMLDivElement>;

  useEffect(() => {
    const handleDrag = (e) => {
      e.preventDefault();

      if (e.dataTransfer?.items?.length > 0) {
        if (ref.current instanceof HTMLElement) {
          ref.current.classList.add('file-dragging');
        }
      }
    };

    const handleDragOut = debounce((e) => {
      e.preventDefault();
      (ref.current as HTMLElement).classList.remove('file-dragging');
    });

    const handleDrop = (e) => {
      e.preventDefault();
      (ref.current as HTMLElement).classList.remove('file-dragging');

      if (e.dataTransfer?.files?.length > 0) {
        onDrop(e.dataTransfer.files);
        e.dataTransfer.clearData();
      }
    };

    const div = ref.current as HTMLElement;
    div.addEventListener('dragleave', handleDragOut);
    div.addEventListener('dragover', handleDrag);
    div.addEventListener('drop', handleDrop);

    return () => {
      div.removeEventListener('dragleave', handleDragOut);
      div.removeEventListener('dragover', handleDrag);
      div.removeEventListener('drop', handleDrop);
    };
  }, [ref, onDrop]);

  return (
    <div id={id} ref={ref} className={classes}>
      {children}
    </div>
  );
};

export default DragDrop;
